import { opacity, Token } from '@revolut-internal/ui-kit'

const HEAT_MAP_THRESHOLD = 10
const HEAT_MAP_NEGATIVE_LENGTH = 8
const HEAT_MAP_POSITIVE_LENGTH = 3
const HEAT_MAP_COLORS = [
  ...Array.from({ length: HEAT_MAP_NEGATIVE_LENGTH }, (_, index) =>
    opacity(
      Token.colorChannel.orange,
      Number(((HEAT_MAP_NEGATIVE_LENGTH - index) * 0.1).toFixed(1)),
    ),
  ),
  ...Array.from({ length: HEAT_MAP_POSITIVE_LENGTH }, (_, index) =>
    opacity(Token.colorChannel.green, Number(((index + 1) * 0.3).toFixed(1))),
  ),
]

export const getFullRangeHeatMapColor = (value: number) => {
  const heatMapIndex = Math.floor(value / HEAT_MAP_THRESHOLD)

  return HEAT_MAP_COLORS[
    heatMapIndex <= HEAT_MAP_COLORS.length ? heatMapIndex : HEAT_MAP_COLORS.length - 1
  ]
}
